module.exports = __webpack_public_path__ + "static/img/12.9cb9334.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/zh/12.png
// module id = NF5K
// module chunks = 0